<div class="modal inmodal fade in create-modal show">
    <div class="modal-dialog">
        <div class="modal-content">
            <form #form="ngForm" (submit)="onSubmit(form)">
                <div class="modal-header">
                    <button type="button" class="close" (click)="closeModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title col-sm-8">User personal data updates</h4>
                </div>

                <div class="modal-body" [class.p-xxs]="!isShowSpinner">

                    <div *ngIf="isDeleteAction()" class="table-responsive">
                        <h3>Resident Move Out</h3>
                        <table class="table table-borderless table-striped m-b-none" [ngClass]="{busy: isShowSpinner}">
                            <thead>
                                <tr>
                                    <td></td>
                                    <td><strong class="pt-1 d-block">Information</strong></td>
                                    <td class="cell-action">
                                        <button type="button"
                                                (click)="deleteUser = true"
                                                class="btn btn-block btn-outline btn-outline-success">
                                            Approve
                                        </button>
                                    </td>
                                    <td class="cell-action">
                                        <button type="button"
                                                (click)="deleteUser = false"
                                                class="btn btn-block btn-outline btn-outline-danger">
                                            Decline
                                        </button>
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr [ngClass]="{'row-danger': form.submitted && inputRadioModel.hasError('required')}">
                                    <td class="cell-title">
                                        <strong>Resident</strong>
                                    </td>
                                    <td class="cell-data">{{patch.suiteUser.user.fullName}}</td>
                                    <td class="cell-action text-center">
                                        <label class="form-check form-check-inline mcc-radio mcc-radio-approve">
                                            <input class="form-check-input" [(ngModel)]="deleteUser" type="radio"
                                                   name="row" #inputRadioModel='ngModel' [required]="true" [value]="true">
                                            <span class="form-check-label">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" id="status_success_borderless" width="100%" height="100%"><path d="M9.866 12.095l-1.95-1.95a.462.462 0 0 0-.647.01l-.964.964a.46.46 0 0 0-.01.646l3.013 3.014a.787.787 0 0 0 1.106.008l.425-.425 4.854-4.853a.462.462 0 0 0 .002-.659l-.964-.964a.468.468 0 0 0-.658.002l-4.207 4.207z"></path></svg>
                                            </span>
                                        </label>
                                    </td>
                                    <td class="cell-action text-center">
                                        <label class="form-check form-check-inline mcc-radio mcc-radio-decline">
                                            <input class="form-check-input" [(ngModel)]="deleteUser" type="radio"
                                                   name="row" #inputRadioModel='ngModel' [required]="true" [value]="false">
                                            <span class="form-check-label">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" id="status_failed_borderless" width="100%" height="100%"><path d="M11 9.38L8.798 7.178a.455.455 0 0 0-.65.006l-.964.965a.462.462 0 0 0-.006.65L9.38 11l-2.202 2.202a.455.455 0 0 0 .006.65l.965.964a.462.462 0 0 0 .65.006L11 12.62l2.202 2.202a.455.455 0 0 0 .65-.006l.964-.965a.462.462 0 0 0 .006-.65L12.62 11l2.202-2.202a.455.455 0 0 0-.006-.65l-.965-.964a.462.462 0 0 0-.65-.006L11 9.38z"></path></svg>
                                            </span>
                                        </label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div *ngIf="!isDeleteAction()" class="table-responsive">
                        <table *ngIf="changes" class="table table-borderless table-striped m-b-none" [ngClass]="{busy: isShowSpinner}">
                            <thead>
                                <tr>
                                    <td></td>
                                    <td>
                                        <strong class="pt-1 d-block">Current Information</strong>
                                    </td>
                                    <td>
                                        <strong class="pt-1 d-block">Updated Information</strong>
                                    </td>
                                    <td class="cell-action">
                                        <button type="button" (click)="checkAll(solution.approve)"
                                                class="btn btn-block btn-outline btn-outline-success">
                                            Approve All
                                        </button>
                                    </td>
                                    <td class="cell-action">
                                        <button type="button"
                                                (click)="checkAll(solution.decline)"
                                                class="btn btn-block btn-outline btn-outline-danger">
                                            Decline All
                                        </button>
                                    </td>
                                </tr>
                            </thead>

                            <tbody>
                                <ng-container *ngFor="let row of changes; let i=index">
                                    <tr *ngIf="row.patched"
                                        [ngClass]="{'row-same' : !row.changed || row.ignore, 'row-danger': form.submitted && inputRadioModel.hasError('required')}">
                                        <td class="cell-title">
                                            <strong>{{row.title}}</strong>
                                        </td>
                                        <td class="cell-data">
                                            <ng-container *ngTemplateOutlet="!row.oldData?.length ? emptyTpl : rowTpl[row.type]; context: {data: row.oldData}"></ng-container>
                                        </td>
                                        <td class="cell-data">
                                            <ng-container *ngTemplateOutlet="!row.changed ? noChange : !row.newData?.length ? emptyTpl : rowTpl[row.type]; context: {data: row.newData}"></ng-container>
                                        </td>
                                        <td class="cell-action text-center">
                                            <label class="form-check form-check-inline mcc-radio mcc-radio-approve">
                                                <input class="form-check-input" [(ngModel)]="row.solution" type="radio"
                                                       [disabled]="row.ignore" name="row-{{i}}"
                                                       #inputRadioModel='ngModel' [required]="row.changed"
                                                       [value]="solution.approve">
                                                <span class="form-check-label">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" id="status_success_borderless" width="100%" height="100%"><path d="M9.866 12.095l-1.95-1.95a.462.462 0 0 0-.647.01l-.964.964a.46.46 0 0 0-.01.646l3.013 3.014a.787.787 0 0 0 1.106.008l.425-.425 4.854-4.853a.462.462 0 0 0 .002-.659l-.964-.964a.468.468 0 0 0-.658.002l-4.207 4.207z"></path></svg>
                                                </span>
                                            </label>
                                        </td>
                                        <td class="cell-action text-center">
                                            <label class="form-check form-check-inline mcc-radio mcc-radio-decline">
                                                <input class="form-check-input" [(ngModel)]="row.solution" type="radio"
                                                       [disabled]="row.ignore" name="row-{{i}}"
                                                       #inputRadioModel='ngModel'
                                                       [required]="row.changed" [value]="solution.decline">
                                                <span class="form-check-label">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" id="status_failed_borderless" width="100%" height="100%"><path d="M11 9.38L8.798 7.178a.455.455 0 0 0-.65.006l-.964.965a.462.462 0 0 0-.006.65L9.38 11l-2.202 2.202a.455.455 0 0 0 .006.65l.965.964a.462.462 0 0 0 .65.006L11 12.62l2.202 2.202a.455.455 0 0 0 .65-.006l.964-.965a.462.462 0 0 0 .006-.65L12.62 11l2.202-2.202a.455.455 0 0 0-.006-.65l-.965-.964a.462.462 0 0 0-.65-.006L11 9.38z"></path></svg>
                                                </span>
                                            </label>
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                    <spinner [spinnerShow]="isShowSpinner"></spinner>
                </div>
                <div class="modal-footer">
                    <spinner class="pull-left" [spinnerShow]="!allPatches.length"></spinner>
                    <span *ngIf="allPatches.length" class="pull-left count">
                        {{patchIndex + 1}} of {{allPatches.length}}
                    </span>
                    <button *ngIf="allPatches.length > 1" class="btn btn-primary"
                            type="button" (click)="approveAll()">
                        <span *ngIf="!autoApprove">Approve All Residents</span>
                        <span *ngIf="autoApprove">Stop</span>
                    </button>
                    <button *ngIf="allPatches.length > 1" class="btn btn-secondary"
                            type="button" (click)="goToNext()" [disabled]="isShowSpinner || !allPatches.length">
                        Skip
                    </button>
                    <button class="btn btn-primary" type="submit" [disabled]="isShowSpinner">Apply</button>
                </div>
            </form>
        </div>
    </div>
    <div class="modal-backdrop fade in" (click)="closeModal()"></div>
</div>


<!--================================-->
<!-- ======= Cell templates ======= -->
<!--================================-->

<!-- Name template -->
<ng-template #nameTpl let-data="data">
    <span>{{data}}</span>
</ng-template>

<!-- Email template -->
<ng-template #emailTpl let-data="data">
    <span>{{data}}</span>
</ng-template>

<!-- Photo template -->
<ng-template #photoTpl let-data="data">
    <span class="photo-pic" *ngIf="data">
        <img alt="User Photo" [src]="data">
    </span>
</ng-template>

<!-- Groups template -->
<ng-template #groupsTpl let-data="data">
    <ul class="data-list">
        <li *ngFor="let item of data">
            {{ getGroupTitle(item.group) || item.group }}
        </li>
    </ul>
</ng-template>

<!-- Address template -->
<ng-template #addressTpl let-data="data">
    <ul class="data-list">
        <li *ngFor="let item of data">
            {{item.address}}<br/>
            {{item.city}} {{item.state}} {{item.postalCode}}
        </li>
    </ul>
</ng-template>

<!-- Phones template -->
<ng-template #phoneTpl let-data="data">
    <ul class="data-list">
        <li *ngFor="let item of data">
            {{item.phone}}
            <small>({{getPhoneTypeTitle(item.phoneType)}})</small>
        </li>
    </ul>
</ng-template>

<!-- Date template -->
<ng-template #dateTpl let-data="data">
    <span>{{data | date}}</span>
</ng-template>

<!-- Emergency Contact template -->
<ng-template #emergencyContactTpl let-data="data">
    <ul class="data-list">
        <li *ngFor="let item of data">
            <span *ngIf="item.isPrimary" title="Is Primary">*</span>
            {{item.name}} {{item.relation}} {{item.phone}} {{item.email}} <br>
            {{item.note}}
        </li>
    </ul>
</ng-template>

<!-- Vehicle template -->
<ng-template #vehicleTpl let-data="data">
    <ul class="data-list">
        <li *ngFor="let item of data">
            {{ item.brand ? item.brand : ''}} {{item.model ? item.model : ''}} {{ item.licensePlate }}
        </li>
    </ul>
</ng-template>

<!-- Pet template -->
<ng-template #petTpl let-data="data">
    <ul class="data-list">
        <li *ngFor="let item of data">
            {{ item.name}}
            <small *ngIf="item.petType">({{getPetTypeTitle(item.petType) || item.petType}})</small>
        </li>
    </ul>
</ng-template>

<!-- Tenant template -->
<ng-template #tenantTpl let-data="data">
    <ul class="data-list">
        <li *ngFor="let item of data">
            {{item.fullName}} <br/>
            <small>{{item.email}}</small>
        </li>
    </ul>
</ng-template>

<!-- Not changed value template-->
<ng-template #noChange>No Change</ng-template>

<!-- Empty value template -->
<ng-template #emptyTpl>Removed</ng-template>



// WEBPACK FOOTER //
// /app/src/app/components/user-updates-modal/user-updates-modal.component.html